import _get from 'lodash/get';

import { findAllValues } from 'utils/DICTIONARY';

export default function formatLockRequestType(method) {
  const methodsMap = findAllValues('request_lock_type') || {};
  return _get(methodsMap, method, '');
}
